import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';

export default class VideoCarousel extends Component {
    state = {
        per_page: this.props.perPage ?? 1,
        start: 0,
    };

    previous = () => {
        const { per_page, start } = this.state;
        const { videos } = this.props;

        let new_start = start - per_page;
        if (new_start < 0) {
            new_start = (Math.floor(videos.length / per_page) * per_page) - per_page;
        }

        this.setState({ start: new_start });
    };

    next = () => {
        const { per_page, start } = this.state;
        const { videos } = this.props;

        let new_start = start + per_page;
        if (new_start >= videos.length) {
            new_start = 0;
        }

        this.setState({ start: new_start });
    };

    render() {
        const { videos, arrowColour } = this.props;
        const { start, per_page } = this.state;

        return (
            <div className="relative py-10 md:py-6 md:px-5">
                {videos.length > per_page && start > 0 && (
                    <div
                        className={`absolute left-auto right-12 md:right-auto md:left-0 top-0 md:top-1/2 transform -translate-y-1/2 flex justify-center select-none cursor-pointer transition duration-200 hover:scale-110 ${arrowColour ? arrowColour : 'text-red-500'}`}
                        onClick={this.previous}
                    >
                        <FontAwesomeIcon icon={faCaretLeft} size="3x" className="flex text-app-blue" />
                    </div>
                )}

                <div className={`md:grid grid-cols-${per_page}`}>
                    {videos
                        .filter((video, i) => i >= start && i < start + per_page)
                        .map((video, i) => (
                            <div key={i} className="md:px-4">
                                <div className="relative" style={{ padding: '56.25% 0 0 0' }}>
                                    <iframe
                                        className="absolute inset-0 w-full h-full rounded"
                                        src={video}
                                        frameBorder="0"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                        ))}
                </div>

                {videos.length > per_page && start + per_page < videos.length && (
                    <div
                        className={`absolute right-0 top-0 md:top-1/2 transform -translate-y-1/2 flex justify-center select-none cursor-pointer transition duration-200 hover:scale-110 ${arrowColour ? arrowColour : 'text-pink-500'}`}
                        onClick={this.next}
                    >
                        <FontAwesomeIcon icon={faCaretRight} size="3x" className="flex" />
                    </div>
                )}
            </div>
        );
    }
}
